export const GET_URL = 'GTAXPRO_TUTORIAL/GET_TUTORIAL_URL';
export const LOADER_STATUS = 'GTAXPRO_TUTORIAL/LOADER_STATUS';

